// src/components/UserAvatar.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

const UserAvatar = () => {
  const navigate = useNavigate();
  const { user, logoutUser, viewMode } = useAuth();

  if (!user) return null;

  const getAvatarInitials = () => {
    const fullName = (user.full_name || user.name || "").trim();
    if (fullName) {
      const initials = fullName
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join("");
      if (initials) return initials;
    }

    const username = (user.username || "").trim();
    if (username) {
      return username.charAt(0).toUpperCase();
    }

    return "U";
  };

  const handleLogout = () => {
    logoutUser();
    navigate("/");
  };

  const handleAvatarClick = () => {
    if (viewMode === "vendor") {
      navigate("/vendor/dashboard");
    } else if (viewMode === "school") {
      navigate("/school/dashboard");
    } else if (viewMode === "agent") {
      navigate("/agent/dashboard");
    }
    
  };

  if (viewMode === "vendor" || viewMode === "school" || viewMode === "agent") {
    // 🔹 Just a clickable circle redirect
    return (
      <div
        className="user-avatar-circle cursor-pointer"
        onClick={handleAvatarClick}
        title="Go to Dashboard"
        style={{
          width: 38,
          height: 38,
          borderRadius: "50%",
          background: "#007bff",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        {getAvatarInitials()}
      </div>
    );
  }

  // 🔹 Default: user dropdown
  return (
    <Dropdown className="user-dropdown">
      <Dropdown.Toggle
        variant="transparent"
        id="dropdown-basic"
        className="user-avatar-toggle"
      >
        <div className="user-avatar-circle">
          {getAvatarInitials()}      
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu align="end" className="user-dropdown-menu">
        <Dropdown.Item onClick={() => navigate("/dashboard/profile")}>
          <i className="fas fa-user me-2"></i> Profile
        </Dropdown.Item>
        <Dropdown.Item onClick={() => navigate("/dashboard/schedule")}>
          <i className="fas fa-calendar-alt me-2"></i> My Progress
        </Dropdown.Item>
        <Dropdown.Item onClick={() => navigate("/dashboard/progress")}>
          <i className="fas fa-chart-line me-2"></i> Mock Test
        </Dropdown.Item>
        <Dropdown.Item onClick={() => navigate("/dashboard/feedback")}>
          <i className="fas fa-comment me-2"></i> Feedback
        </Dropdown.Item>
        <Dropdown.Item onClick={() => navigate("/dashboard/notification")}>
          <i className="fas fa-bell me-2"></i> Notifications
        </Dropdown.Item>
       <Dropdown.Divider />

<Dropdown drop="start">
  <Dropdown.Toggle variant="light" className="w-100 text-start">
    <i className="fas fa-cog me-2"></i> Settings
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item
      onClick={() => navigate("/dashboard/profile?tab=personal")}
    >
      <i className="fas fa-user-edit me-2"></i> Edit Profile
    </Dropdown.Item>
   <Dropdown.Item
  onClick={() => navigate("/dashboard/profile?tab=security&security=true")}
>
  <i className="fas fa-lock me-2"></i> Security
</Dropdown.Item>
    <Dropdown.Divider />

    <Dropdown.Item onClick={handleLogout}>
      <i className="fas fa-sign-out-alt me-2"></i> Logout
    </Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserAvatar;
